<template>
  <div class="container">
    <form
      name="test"
      style="margin: 0 auto; max-width: 700px;"
      @submit.prevent="onSubmit"
    >
      <base-select
        name="company"
        v-validate="'required'"
        label="Company"
        select-label="name"
        v-model="company"
        :options="userCompanies"
        :err="formErrors.company"
      />
      <base-select
        select-label="name"
        name="country"
        v-validate="'required'"
        label="Country of collection"
        v-model="country"
        :options="countries"
        :err="formErrors.country"
      />
      <base-date
        name="month"
        v-validate="'required'"
        label="Month of processing"
        v-model="collection_date"
        format="YYYY-MM"
        :err="formErrors.month"
      />
      <div v-if="isInput === true">
        <base-select
          select-label="name"
          name="material"
          v-validate="'required'"
          label="Material"
          v-model="material"
          :options="materials"
          :searchable="true"
          :err="formErrors.material"
        />
      </div>
      <div v-if="isInput === false">
        <base-text
          name="human_name"
          v-validate="'required'"
          label="Product Name"
          v-model="human_name"
          :err="formErrors.human_name"
        ></base-text>
        <base-text
          name="name"
          v-validate="'required'"
          label="Product ID"
          v-model="name"
          :err="formErrors.name"
        ></base-text>
      </div>
        <div class="row mt-4">
        <div class="col-6 text-left"></div>
        <div class="col-6 text-right">
            <base-button
            radius="br"
            component-class="green filled"
            type="submit"
            >Submit &amp; Go Next <i class="fas fa-arrow-right ml-3"></i>
            </base-button>
        </div>
        </div>
    </form>
  </div>
</template>

<script>
  import * as moment from 'moment';
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import BaseText from '@/components/inputs/text/BaseText';
  import BaseDate from '@/components/inputs/text/BaseDate';
  import BaseSelect from '@/components/inputs/select/BaseSelect';
  import BaseButton from '@/components/inputs/button/BaseButton';
  import randomString from '@/helpers/randomString';
  import randomInt from '@/helpers/randomInt';

  import stepValidators from '../StepValidators';

  export default {
    data() {
      return {
        company: null,
        country: null,
        collection_date: '',
        material: null,
        name: '',
        human_name: '',
        formErrors: {
          company: [],
          country: [],
          month: [],
        },
      };
    },

    computed: {
      ...mapState({
        userCompanies: state => state.userCompanies.loggedUserCompanies,
        countries: state => state.countries.countries,
        baseData: state => state.submitWaste.baseData,
        isInput: state => state.user.user.is_input,
      }),
      ...mapGetters({
        materials: 'materials/flatMaterials',
      }),
    },

    methods: {
      ...mapActions({
        // getUserCompanies: 'userCompanies/getCompanies',
        // getCountries: 'countries/getCountries',
        getMaterials: 'materials/materials',
      }),
      ...mapMutations({
        setBaseData: 'submitWaste/setBaseData',
        setInputSecondData: 'submitWaste/setInputSecondData',
      }),
      async displayErrors() {
        this.formErrors = {
          company: [],
          country: [],
          month: [],
        };
        const errors = await this.$validator.errors.items;
        errors.forEach((error) => {
          this.formErrors[error.field] = [error.msg];
        });
      },
      async onSubmit () {
        const isFormValid = await this.$validator.validateAll();

        await this.displayErrors();
        if (isFormValid) {
          this.$store.commit('submitWaste/setStepsValidation', {
            stepId: 2,
            isValid: true,
          });
          const { company, country, collection_date } = this;
          if (this.isInput) {
            const { material } = this;
            this.setBaseData({ company, country, collection_date, material });
            this.$router.push({ name: 'submit-waste-input' });
          }
          if (this.isInput === false) {
            const { name, human_name } = this;
            this.$store.commit('submitWaste/setBaseData', {
              company,
              country,
              collection_date,
              human_name,
              name,
            });
            this.$router.push({ name: 'submit-waste-output' });
          }
        }
      },
    },

    async mounted () {
      // await this.getUserCompanies(this.$store.getters['user/getLoggedInUserId']);
      // this.getCountries();
      this.getMaterials();
      this.company = this.baseData.company;
      this.country = this.baseData.country;
      this.collection_date = this.baseData.collection_date;
      this.material = this.baseData.material;
      this.human_name = this.baseData.human_name;
      this.name = this.baseData.name;
      if (!this.collection_date) {
        this.collection_date = moment(moment(new Date()), 'YYYY-MM').format('YYYY-MM');
      }

      if (this.name === '') {
        this.name = `${randomString(4)}-${randomInt(1000, 9999)}`;
      }
      stepValidators.register(1, async () => {
        const isFormValid = await this.$validator.validateAll();
        return isFormValid;
      });
    },

    components: {
      'base-text': BaseText,
      'base-date': BaseDate,
      'base-select': BaseSelect,
      'base-button': BaseButton,
    }
  };

</script>
